/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { KEY_STATUS_LABELS } from '../constants';

// Situação da chave: ativa (verde) × revogada (vermelho). Aqui o vermelho cabe:
// uma credencial revogada bloqueia emissão nova, é um estado que exige ação.
export default function CredentialStatusBadge({ value }) {
   const label = KEY_STATUS_LABELS[value] ?? value ?? '—';
   return (
      <StatusBadge variant={value === 'active' ? 'green' : 'red'}>
         {label}
      </StatusBadge>
   );
}

CredentialStatusBadge.propTypes = {
   value: PropTypes.string,
};
